
export default {
    home: {
        index: "首页",
        title: "协谷国际",
        talent: "专业才能",
        talent1: "综合物流",
        talentIntroduce1: "凭藉在众多市场领域的优越往绩，六渡物流精于为国际时装及电子品牌、餐饮连锁店、快消品公司，以至医药、工业及汽车行业提供专属解决方案。",
        talent2: "空运",
        talentIntroduce2: "作为各个主要航空公司的 IATA 专署代理，六渡物流提供完善的空运服务，从出发点提货、多重整合、清关，以至将货物交付至终端客户。",
        talent3: "海运",
        talentIntroduce3: "凭藉与海运承运商建立的强大网络，六渡物流为你提供可靠及具经济效益的海运服务，当中包括各类型传统货运、整箱承运及拼箱承运。",
        talent4: "陆路货运",
        talentIntroduce4: "凭藉贯通欧亚的完善陆路、铁路网络，六渡物流提供创新及具经济效益的陆运服务，支援中国、中亚与世界各地的环球贸易活动。",
        talent5: "工业项目物流",
        talentIntroduce5: "Ladoo Project Logistics是六渡物流为满足综合项目物流服务不断增长的需求而建立的专业团队，由逾220名行业专才组成，通过紧密合作在世界各地全面管理各种复杂项目。",
        talent6: "电子商贸",
        talentIntroduce6: "为支持线上到线下业务，我们提供全面的电子商贸解决方案，从「B2B」、「B2C」到「B2B2C」，我们均可满足你的市场营销和物流需求。",
        talent7: "供应链解决方案",
        talentIntroduce7: "环球供应链日趋复杂及多面向。为支援你在多国的采购、生产和配送活动，六渡物流提供高度量身订制的解决方案，以满足你的独特需求。",
        talent8: "快递",
        talentIntroduce8: "六渡物流透过Ladoo Express品牌在亚洲提供创新、可靠和具成本效益的包裹快递服务，业务覆盖泰国、越南、马来西亚、柬埔寨、印尼、台湾和香港。",
        plan: "行业解决方案",
        plan1: "时尚服饰及精品",
        planIntroduce1: "六渡物流为众多品牌提供量身订制的供应链解决方案，涵盖奢侈及轻奢侈品、快速时装、运动服饰、美容产品、配饰，以及精品，每天服务的商店数以万计。",
        plan2: "电子科技",
        planIntroduce2: "凭借与国际高科技品牌的多年合作经验，六渡物流提供完整及高效率的供应链，由进厂与生产、出厂与配送、以至售后物流及逆向物流服务等，皆一应俱全。",
        plan3: "食品及饮料",
        planIntroduce3: "六渡物流拥有多年的冷链物流经验，为零售连锁店、酒店及餐厅等提供设有完善冷链服务的食品及饮料解决方案。",
        plan4: "葡萄酒及烈酒",
        planIntroduce4: "我们的葡萄酒及烈酒物流专家团队拥有丰富经验，为全球众多名酒和烈酒商人、鉴赏家、拍卖人和经销商提供服务。",
        plan5: "快消品",
        planIntroduce5: "六渡物流为快消品行业提供专业及具有成本效益的物流服务，确保能迅速运送大批量货物，以及有效率地管理供应链上的生产商和供应商。",
        plan6: "医药",
        planIntroduce6: "六渡物流在医药物流上一直秉承「谨慎处理」的宗旨。我们深明医药行业的关键要求，并了解我们运送的货物将用作拯救生命。",
        plan7: "工业及物料科技",
        planIntroduce7: "六渡物流为各类型工业和化学产品提供完善解决方案，涵盖工业化学品、建筑材料、机械及零件、消费化学品等不同行业。",
        plan8: "汽车",
        planIntroduce8: "六渡物流为汽车行业提供综合供应链解决方案，当中包括原材料的采购和供应、工厂生产、出厂汽车交付至终端客户，以及售后物流。",
        aboutUs: "关于我们",
        aboutUsText1: "Ladoo 是一家全球运输和物流服务提供商。每天为数千家公司提供和运营供应链解决方案。我们的运输网络覆盖全球，而专业的本地操作让我们更贴近客户的需求。",
        aboutUsText2: "",
        contactUs: "联系我们",
        ask: "有疑问吗？",
        askText: " 与我们的专家联系，我们随时准备好为您服务并为您提供解决方案。",
        bannerTitle: "您在新兴市场的合作伙伴",
        bannerText: "六渡物流在全球一半的新兴市场中有稳固的业务，包括多元化的基础设施、广泛的地面支援和本地专业知识，遍及中国內地、印度、东南亚、独联体、中东、拉美和更多地区。观看我们于不同市场和行业的服务短片，了解更多我们提供的服务"
    },
    talent: {
        typeName0: '综合物流',
        typeContent0: [
            {
                title: '',
                text0: '凭藉在众多市场领域的优越往绩，六渡物流精于为国际时装及电子品牌、餐饮连锁店、快消品公司，以至医药、工业及汽车行业提供专属解决方案。',
                text1: '拥有遍布亚洲及跨越全球的强大网络及多元化基建设施，六渡物流为你的业务提供由提货点至目的地间之广泛地面支援。',
                text2: '完善服务包括专业的仓储及配送、本地陆路货运、库存管理、逆向物流、多元化的增值服务等。',
                text3: '六渡物流深得众多全球百强品牌信任，定能为你提供合适的解决方案。',
            },
            {
                title: '仓储及配送',
                text0: '六渡物流在各个重要领域持续投放资源，确保客户获得杰出的服务。',
                text1: '我们在亚太区作策略性选址，策划及兴建一系列物流中心，并建立亚洲强大的陆路运输车队。',
                text2: '我们于世界各地管理6,400万平方尺的物流设施，提供多种专属及共享的仓储和配送运营模式，以满足每一位客户的独特需求。',
                text3: '完善的专业服务包括医药、冷链、危险品和保税品营运，以及零售准备服务和售后服务等。',
            },
            {
                title: '增值服务',
                text0: '六渡物流在原产地及目的地为客户提供多完化的增值服务，满足从时装到电子、食品饮料到医药品、快速消费品到汽车等众多行业的特定需求。',
            },
            {
                title: '物流设施',
                text0: '我们于世界各地管理6,900万平方尺的物流设施，提供多种专属及共享的仓储和配送运营模式，以满足每一位客户的独特需求。',
                text1: '完善的专业服务包括医药、冷链、危险品和保税品营运，以及零售准备服务和售后服务等。',
            }
        ],
        typeName1: '空运',
        typeContent1: [
            {
                title: '',
                text0: '作为航空公司的 IATA 专署代理，六渡物流提供完善的空运服务，从出发点提货、多重整合、清关，以至将货物交付至终端客户。凭藉强大的环球空运网络，我们能助你拓展业务至世界每一个市场。',
                text1: '我们全天候24小时营运，确保你的产品能以短运输时间、理想航线及具成本效益的方式运抵目的地。凭藉我们的LadooVISION 资讯科技平台，助你由提货至最终交付期间随时追踪货件，让你安枕无忧。',
            },
            {
                title: '空运包机',
                text0: '为满足你对紧急货运或规划性项目的物流需求，六渡物流透过合适的飞机型号和环球航线，为你提供专业及完善的空运包机服务。',
                text1: '我们的空运专才致力提供优越及具成本效益的解决方案，满足各项指定要求。我们的广泛网络覆盖各个主要国际机场，定能为你的货物预订合适的飞机型号及航线。',
                text2: '凭藉我们的LadooVISION 资讯科技平台，助你由提交订单至最终交付期间随时追踪及监察整个空运包机项目，让你安枕无忧。',
            },
            {
                title: '海空运及空海运',
                text0: '六渡物流结合海运的经济效益与空运的速度，以理想的运费和路线，提供量身订制及灵活的环球多式联运解决方案。',
                text1: '我们的海空联运服务以统一程序处理，整个运输过程只需单一运费率及单一文件，并为你妥善处理沿途所有海关手续和货运文件，让你安枕无忧。',
                text2: '透过我们的LadooVISION 资讯科技平台，你可如单一空、海运般轻松追踪货件。'
            },
            {
                title: '集运',
                text0: '凭藉我们强大的空运网络，以及与全球各大主要领先订舱代理的紧密伙伴关系，六渡物流提供具成本效益及多方面的多国集运服务。这项服务透过合并不同货物以充分利用货柜空间，有效降低成本及缩短运输时间。',
                text1: '我们亦为你提供代理报关、检验、质量管理及分类服务，为你的货物提供严密的保障。',
                text2: '透过我们的LadooVISION 资讯科技平台，你可由提货至最终交付期间随时追踪货件，让你安枕无忧。'
            },
            {
                title: '货运总代理',
                text0: '六渡物流专注于亚洲，是各大主要航空公司于众多战略性市场的货运总代理，致力提供理想货运航线、服务及运费。',
                text1: '我们的货运总代理团队具备各种业务领域的丰富经验和资历，对专业及终端用户市场的市场资讯、产品开发，以至销售及营销、预订及票务支援均了如指掌。',
            },
            {
                title: '限时产品',
                text0: '六渡物流为客户提供一系列限时的快运选项。这些选项提供全球一致性及精简的服务，以提升客户体验。我们的专业客户服务团队将根据你的需求配对服务组合，并透过LadooVISION信息科技平台提供货件的实时情况。',
                text1: '凭藉六渡物流广泛的本地配送网络，我们亦会提供门到门送递服务，保证货件能在你指定的转运时间内被提取及顺利送递。',
            },
        ],
        typeName2: '海运',
        typeContent2: [
            {
                title: '',
                text0: '凭藉与海运承运商建立的强大网络，六渡物流为你提供可靠及具经济效益的海运服务，当中包括各类型传统货运、整箱承运及拼箱承运。',
                text1: '不论任何指定路线、航班密度和运送时间，我们的无船承运服务均能确保客户的货物准时送达。',
                text2: '我们灵活的海运解决方案，可助你以具竞争力的运费运送大量及交货期长的货物。',
                text3: '透过我们的LadooVISION资讯科技平台，你可沿供应链追踪货运进度，安枕无忧。',
            },
            {
                title: '集运',
                text0: '凭藉我们强大的海运网络，以及与全球各大主要订舱代理的紧密伙伴关系，六渡物流提供多方面及具成本效益的多国集运服务。这项服务透过合并不同货物以充分利用货柜空间，有效降低运输成本及缩短中转时间。',
                text1: '我们亦提供报关及申报代理、检验、质量管理及分类服务，为你的货物提供严密的保障。',
                text2: '透过我们的LadooVISION 资讯科技平台，你可由提货至最终交付期间随时追踪货件，安枕无忧。',
            },
            {
                title: '无船承运、整箱及拼箱',
                text0: '六渡物流提供整箱及拼箱无船承运方案。服务包括合约管理、拼箱、拆箱，以及单一或多国买家集运服务。',
                text1: '整箱及拼箱发货点覆盖全球所有主要港口，提供高灵活度及成本效益的解决方案，以满足你的环球供应链需要。我们将整箱或拼箱货运，连接至其他空、陆及铁路货运方案，并提供上、下游仓储和配送支援，为你提供完整的货运方案。',
                text2: '透过我们的LadooVISION 资讯科技平台，你可由提货至最终交付期间随时追踪货件。',
            },
            {
                title: '分拨',
                text0: '六渡物流能为一般货件及体积特大、形状独特、重吊货物和钢铁等产品，在货运前及中期提供完善的分拨解决方案。同时提供附加服务，包括包装、条板箱装箱及索具吊装等，确保货物获得妥善的保护。',
                text1: '我们与全球主要的海运承运商合作，提供多元化的远洋轮船、货柜及拖车选择，满足你独特的货运需要。我们亦能在你的亚洲主要生产基地及终端市场附近，提供上、下游仓储和配送支援服务。',
                text2: '透过我们的LadooVISION 资讯科技平台，你可由提货至最终交付期间随时追踪货件。',
            },
            {
                title: '订舱代理',
                text0: '六渡物流凭藉与主要海运承运商的长期合作关系，提供直接可靠及专业的海运服务。',
                text1: '作为众多主要海运公司的订舱代理，我们能完全控制船舱的空间分配，为你提供具竞争力的运费及航线。',
            },
            {
                title: '海运管理',
                text0: '高效率、安全及准时地将你的货物送抵目的地，是六渡物流海运服务的重要原则。我们了解文件的繁复程序，并代为妥善处理所有行政细节。',
                text1: '我们严格监督整个海运过程，从确认预订、码头交收、装船提单、报关及申报代理，以至货物追踪及货到通知等，均兼顾周全。',
                text2: '透过我们的LadooVISION资讯科技平台，你可在供应链的任何环节取得货运状态报告，让你安枕无忧。',
            },
        ],
        typeName3: '陆路货运',
        typeContent3: [
            {
                title: '',
                text0: '凭藉贯通欧亚的完善陆路、铁路网络，六渡物流提供创新及具经济效益的陆运服务，支援中国內地、中亚与世界各地的环球贸易活动。',
                text1: '我们的区域及当地专家团队妥善管理整体陆上营运，由原产地到目的地均可满足每个国家及城市的特定海关要求。',
                text2: '我们在多元化的地区为国际客户提供具成本效益的长途陆运、海陆及空陆货运，以及门到门送递服务，由提货、集货以至清关，一应俱全。',
                text3: '我们致力配合你的特定行业要求，并在你的指定运输时间内提供高效率及具成本效益的方案。',
                text4: '于亚洲，六渡物流亦提供连接中国內地与东盟的独特跨境陆路运输解决方案「六渡亚洲陆路运输 (KART) 」。现时我们营运八条服务路线，由中国內地至泰国、越南、老挝、柬埔寨、缅甸、新加坡与马来西亚等东南亚国家。',
            },
        ],
        typeName4: '工业项目物流',
        typeContent4: [
            {
                title: '',
                text0: 'Kerry Project Logistics是六渡物流为满足综合项目物流服务不断增长的需求而建立的专业团队，由逾300名行业专才组成，通过紧密合作在世界各地全面管理各种复杂项目。',
                text1: '我们为客户的项目团队提供端对端解决方案，涵盖加速处理、运前检查、物料管理，以至包装、实地测量及可行性研究。凭藉不断扩展的网络，我们可灵活应对不同环球项目的需求，确保运送安全及准时交付。',
            },
        ],
        typeName5: '电子商贸',
        typeContent5: [
            {
                title: '',
                text0: '为支持线上到线下业务，我们提供全面的电子商贸解决方案，从「B2B」、「B2C」到「B2B2C」，我们均可满足你的市场营销和物流需求。我们的全渠道履行解决方案具高透明度，涵盖电子商贸订单履行、跨境配送，以及最后一里派送。',
            },
            {
                title: '开店服务',
                text0: '我们的多渠道网上销售解决方案支持网上零售商在全球网上购物平台上建立和管理网上商店。',
            },
            {
                title: '跨境物流',
                text0: '货物提取----提供循环取货服务，从供货商或工厂提取电子商贸货物，并运送到指定的履行仓库或分类枢纽。',
                text1: '订单履行及仓储----提供在原产地和目的地的仓储服务，进行电子商贸货物订单履行，例如提货 / 包装和重贴标签。',
                text3: '集运----在原产地整合包裹，并合并运送至世界各地，以节省个人买家的国际运输成本。',
                text4: '分类----拥有全自动化分类枢纽，按目的地国家对电子商贸货物进行分类。',
                text5: '国际长途运输----提供跨国家 / 地区的国际货运。',
                text6: '邮政投递----提供专业的邮政投递服务，涵盖多个目的地。',
                text7: '清关----与我们的报关代理合作，提供原产地和目的地的清关解决方案。',
                text8: '最后一里派送----提供本地快递服务予目的地的终端客户。',
                text9: '货到付款----交货时向买家收取付款并汇款给卖家。',
                text10: '逆向物流----凭借我们的环球物流设施网络，提供退货管理、转售、弃置、重贴标签、质量控制及更多服务。',
            },
            {
                title: '订单管理',
                text0: '通过网上追踪、数据分析，以及应用程式介面 (API)集成，与最后一里派送服务供应商进行内部订单管理。',
            },
            {
                title: '包机',
                text0: '提供订制包机以覆盖世界各地的目的地。',
            },
        ],
        typeName6: '供应链解决方案',
        typeContent6: [
            {
                title: '',
                text0: '环球供应链日趋复杂及多面向。为支援你在多国的采购、生产和配送活动，六渡物流提供高度量身订制的解决方案，以满足你的独特需求。',
                text1: '我们的专业客户管理团队不断为国际客户设计崭新营运模式及解决方案，从咨询、设计以至执行和评估皆兼顾周全，可降低库存、缩短货物推出市场时间及大幅节省成本。',
                text2: '透过长期伙伴关系、具竞争力的成本管理，以及持续精益求精，我们致力助你达成在环球、区域及本地的策略性目标。'
            },
        ],
        typeName7: '快递',
        typeContent7: [
            {
                title: '',
                text0: '六渡物流透过Kerry Express品牌在亚洲提供创新、可靠和具成本效益的包裹快递服务，业务覆盖泰国、越南、马来西亚、柬埔寨、印尼和香港。',
                text1: '我们在区内提供「企业对消费者」/「企业对企业对消费者」/「消费者对消费者」电子商贸解决方案，其客户类型广泛，涵盖个人、网络零售商及社交媒体的个人卖方等。',
                text2: '单在泰国，Kerry Express营运超过1,000个配送中心及超过36,000个服务点，拥有多元服务渠道，并提供覆盖全国翌日送递和货到付款服务。',
                text3: '于2020年7月，Kerry Express获领先的营销刊物Marketeer选为2019-2020年度泰国第一品牌。',
                text4: '我们的服务范围包括即日快递、翌日快递、非紧急经济快递服务，以及多元化的增值服务，包括家居送货、重新包装、电子商贸、直销、量身订制服务、网上追踪、网上预约、到场服务、暂存、货到付款、发票退还以及预约送递等。',

            },
        ],
    },
    plan: {
        typeName0: '时尚服饰及精品',
        typeContent0: [
            {
                title: '',
                text0: '六渡物流为众多品牌提供量身订制的供应链解决方案，涵盖奢侈及轻奢侈品、快速时装、运动服饰、美容产品、配饰，以及精品，每天服务的商店数以万计。',
                text1: '我们的时尚服饰及精品解决方案涵盖多国集运、本地 / 区域配送中心履行、订单管理、全渠道履行，以及逆向物流等。',
            },
            {
                title: '多国集运',
                text0: '我们的多国集运解决方案涵盖承运商 / 货运代理管理、店铺直送及电子商贸支援。我们提供具成本效益及高可视度的服务，以整箱及拼箱承运处理来自多个供应商和国家的货运，有效改善负载因素，降低运输成本及缩短货物推出市场时间。',
            },
            {
                title: '全渠道履行',
                text0: '为支持线上到线下业务，我们提供量身订制且具透明度的解决方案，包括电子商贸订单履行、跨境配送及最后一里送递。我们的开店服务亦协助网上零售商在全球的网上购物平台上建立及管理网上商店。',
            },
            {
                title: '本地 / 区域配送中心履行',
                text0: '我们的保税及非保税物流设施覆盖广泛网络，可支持你的本地和区域仓储需要，以及在主要消费市场的全国配送。我们亦提供溢货管理、店铺盘点、高端时装运输的安全封装服务，以及货到付款服务，进一步为你的业务增值。',
            },
            {
                title: '退货管理',
                text0: '我们同步处理补货、退回购买地点、商品陈列管理、专属维修中心支持服务、店内质量检查、重新包装再售、环保弃置以及捐赠服务。',
            },
            {
                title: '增值服务',
                text0: '我们的增值服务包括撷取序号、缝制标签、价格标签、组装、打印射频识别标签 / 国家标签、重新包装等。',
            },
            {
                title: '关税及增值税付款',
                text0: '我们的服务包括咨询进出口报关事宜、关税和增值税付款，以及为关税、增值税预缴及快速EDI缴税提供弹性安排。',
            },
        ],
        typeName1: '电子科技',
        typeContent1: [
            {
                title: '',
                text0: '凭藉与国际高科技品牌的多年合作经验，六渡物流提供完整及高效率的供应链，由进厂与生产、出厂与配送、以至售后物流及逆向物流服务等，皆一应俱全。',
                text1: '我们能迅速回应市场的物流解决方案，确保你能够比竞争对手早一步将新产品送到消费者手中。',
            },
            {
                title: '制造及生产',
                text0: '零件管理----我们为部分亚洲领先的专业零件供应商提供零件管理方案，透过严格的标准操作程序(SOP)确保准确程度高达100.0%。我们的专用设施提供最合适的温度和湿度控制，并有专业团队进行各类型的重贴标签，以满足不同市场需求。',
                text1: '越库运输----我们通过供应商枢纽营运、供应商管理、分类和按时送货到生产线，为你的零件提供越库运输解决方案。我们亦获授权处理战略物品，如集成电路、中央处理器及芯片组等。',
            },
            {
                title: '成品',
                text0: '区域配送中心履行----我们的区域配送中心解决方案涵盖「企业对企业」和「企业对消费者」履行。我们为消费电子产品和家用电器品牌提供符合TAPA标准的仓储、库存管理、组装、延期装运和运输中途组装服务，以满足你的区域履行需求。',
                text1: '本地配送中心履行----我们提供的本地配送中心履行解决方案涵盖组装、到场送递与装嵌、电子签收证明（ePOD）和热线中心支持服务。我们在大中华区拥有广泛的辐射式运输网络，确保你的产品及时送递至终端客户。',
                text2: '跨境集运枢纽----我们位于香港的跨境集运枢纽涵盖收货及按目的地分货，亦提供清关，以及跨境送递至中国內地各城市。',
            },
            {
                title: '售后服务',
                text0: '配件物流----我们为售后配件供应商或经销商提供24小时全天候及各种紧急送递服务，例如一小时补货选项。我们的配件中心符合TAPA标准，并提供现场技术支援。',
                text1: '退货授权----我们的区域 / 全球退货授权中心解决方案涵盖功能测试和评级、重新配置 / 转换、量身订制服务、重贴标签、退货至维修中心或零售店，以至重新包装 / 重新定位再售，以及环保弃置服务。',
            },
            {
                title: '物流以外',
                text0: '供应链融资----我们为客户提供独特的融资解决方案，整合订单管理、融资、信贷管制和物流服务，藉此促进获许可的本地贸易，并让你拥有更好的现金流，同时提高不同渠道的销售透明度。',
                text1: '增值服务----我们的增值服务包括撷取序号、组装、更换插头、加入最后一里用户手册、印贴标签、分货、礼品包装、功能和品质检查、逆向物流等。',
            },
        ],
        typeName2: '食品及饮料',
        typeContent2: [
            {
                title: '',
                text0: '六渡物流拥有多年的冷链物流经验，为零售连锁店、酒店及餐厅等提供设有完善冷链服务的食品及饮料解决方案。',
                text1: '透过实践严格的标准操作程序(SOP)，我们确保所有产品由提货至最终交付均保持合适温度。',
            },
            {
                title: '本地配送中心履行',
                text0: '我们擅长管理大规模本地配送中心运作及复杂配送渠道，往绩卓越。我们的多温层解决方案包括-45°C(低温雪藏)、-25°C(雪藏)、-18°C(冷藏)、0-4°C(冷冻)、12-22°C (空调)，以及常温储存区，适合不同种类产品需要。我们拥有配备GPS的车辆及电子签收证明(ePO)支援的专业常温及冷冻货车车队，能为餐厅及连锁零售店提供每日补货服务。',
            },
            {
                title: '食品工厂 (香港)',
                text0: '我们为食品烹制和制造行业提供多样化的食品包装和重新包装服务，以支援您的本地及区域需求。我们亦透过香港首家半自动肉类加工厂MeatLab，提供创新的食品加工解决方案。我们采用真空贴体包装及气调包装技术，以延长肉类产品的保存期限及保持其新鲜度。',
            },
            {
                title: '越库运输',
                text0: '我们精细的越库运输解决方案使鲜活货物或易受时间影响的产品能够以短的送货时间到达零售商店，保持质量和新鲜度。',
            },
            {
                title: '库存追踪',
                text0: '我们提供综合的库存管理解决方案，由先进仓先出仓 (FIFO) / 先过期先出仓安排(FEFO)、量身订制的存货老化报告、货品按到期日或变质日排序报告，至批次管制，以及半年 / 年度盘点等。通过我们专有的追踪系统，客户可以在产品回收时追踪产品至批次级别。',
            },
            {
                title: '增值服务',
                text0: '我们的增值服务包括印贴标签、捆绑、盖印、礼品包装、季节性礼品篮组装、解冻处理、辅助销售产品处理、品质检查、逆向物流及催熟设施等。',
            },
            {
                title: '冷链速递 (香港)',
                text0: '我们在香港提供翌日冷链快递到家服务，以及多元化的增值服务，包括短信送货提示、网上追踪、货到付款及预约送递等。',
            },
        ],
        typeName3: '葡萄酒及烈酒',
        typeContent3: [
            {
                title: '',
                text1: 'Under the law of Hong Kong, intoxicating liquor must not be sold or supplied to a minor in the course of business. 根据香港法律，不得在业务过程中，向未成年人售卖或供应令人醺醉的酒类。',
                text0: '我们的葡萄酒及烈酒物流专家团队拥有丰富经验，为全球众多名酒和烈酒商人、鉴赏家、拍卖人和经销商提供服务。我们的解决方案涵盖获香港品质保证局认证的优质葡萄酒储存设施，以及货运、配送和一系列增值服务。',
            },
            {
                title: '获认证优质葡萄酒窖 (香港)',
                text0: '我们在香港拥有的私人酒窖，获香港品质保证局「葡萄酒储存管理体系 – 高级葡萄酒」认证，提供合适的温度和湿度控制。酒窖完全隔绝高温和阳光直射，为优质葡萄酒储存提供理想的窖藏条件。为确保酒窖的安全，我们透过专业安全控制系统和24小时录制的闭路电视监控限制出入。我们的葡萄酒物流专责团队确保您极其珍贵及罕有的葡萄酒珍藏，从提货至最终交付均获适切的处理。',
            },
            {
                title: '国际货运',
                text0: '我们的全球网络覆盖所有主要葡萄酒产区，并提供包括空运、海运、陆运、多式联运、转口和三角运输的量身订制解决方案。我们处理来自主要葡萄酒产区的冷藏箱拼箱整合、酒厂提货、重新包装和出口装板，以及报关代理和文件处理。',
            },
            {
                title: '保税品',
                text0: '我们拥有超过60,000平方英尺用于烈酒和香烟储存的危险品保税仓库，并已获相关牌照。凭藉多年的保税仓行动经验，我们为客户提供应课税货物的全面物流解决方案。我们亦拥有葡萄酒和烈酒的进出口牌照，以办理进出口报关。',
            },
            {
                title: '本地配送',
                text0: '我们拥有覆盖酒吧、餐厅、酒店、超市、零售店、私人住宅和办公室的广泛本地网络，确保你的葡萄酒按时送到客户手中。我们的专用温度控制车队提供白手套服务及可靠的优质葡萄酒和烈酒配送，获得香港品质保证局「葡萄酒储存管理体系 – 运输 – 高级葡萄酒」认证。',
            },
            {
                title: '增值服务',
                text0: '我们提供多元化的增值服务，包括品质检查和详细检查报告、包装和重新包装，用于季节性促销的定制礼品包装、印贴标签和日期打印、拍照、水平检查以及拍卖准备。',
            },
        ],
        typeName4: '快消品',
        typeContent4: [
            {
                title: '',
                text0: '六渡物流为快消品行业提供专业及具有成本效益的物流服务，确保能迅速运送大批量货物，以及有效率地管理供应链上的生产商和供应商。我们具競爭力的快消品解决方案，全力协助你的产品以理想的状态、效率和成本竞争力进入市场。',
            },
        ],
        typeName5: '医药',
        typeContent5: [
            {
                title: '',
                text0: '六渡物流在医药物流上一直秉承「谨慎处理」的宗旨。我们深明医药行业的关键要求，并了解我们为客户运送的货物将用作拯救生命。',
                text1: '无论是非处方药物、疫苗和血清、医疗设备或保健品，我们均竭尽所能坚守高安全标准及行业和政府法规。我们的端对端解决方案涵盖物流、贸易、销售及市场推广，以及一系列增值服务，能满足客户任何要求。',
            },
            {
                title: '多方位冷链管理',
                text0: '多方面及完善的冷链物流管理，可确保医药产品于供应链上的任何环节皆保持理想的温度。',
            },
            {
                title: '仓储及配送',
                text0: '我们的设施包括ISO13485、ISO90001和GDP认证及具备湿度与温度控制的仓库。我们的多温层解决方案包括-20°C(冷藏)、2-8°C(冷冻)及15-25°C(常温)，适合不同医药产品需要。我们更提供物流管理服务，以认可车辆及GDP认证的点对点配送到医院、诊所、医药零售门市、家居，以至门到门交付服务，均一应俱全。六渡医药不但能把您的产品直接运送到客户手上，更能助您扩阔销售渠道。',
            },
            {
                title: '增值服务',
                text0: '我们的增值服务包括外包装、采购、热线中心支援服务，以及贸易营销等。',
            }
        ],
        typeName6: '工业及物料科技',
        typeContent6: [
            {
                title: '',
                text0: '六渡物流为各类型工业和化学产品提供多元化的解决方案，涵盖工业化学品、建筑材料、机械及零件、消费化学品等不同行业。',
                text1: '透过与生产商、供应商和终端用户紧密合作，我们提供专业的工业及物料科技解决方案，当中包括物流分析、咨询和设计、工程、包装和运输，以至物流流程优化等，由提货点至目的地的所有程序均符合国际标准。',
            },
            {
                title: '厂内物流',
                text0: '我们提供涵盖设计规划、工程与营运的厂内物流服务，当中包括一系列增值服务：装袋、入桶、散装、量重、包装和重新包装、印贴和重贴标签、标记、抽样、废物弃置，以及逆向物流等。',
            },
            {
                title: '本地 / 区域配送中心履行',
                text0: '我们的综合方案包括保税及非保税仓储、ISO罐式集装箱 / 集装箱管理、仔细至每批次的原料和成品管理，以及量身订制的各种报告。我们的设施拥有各类型所需牌照及ISO认证，以处理不同货物。我们亦提供完整卡板提货、个别产品提货和包装，或拼箱 / 整箱包装出口运输等服务。',
            },
            {
                title: '危险品物流',
                text0: '我们拥有相关的危险品牌照，符合资格提供危险品仓储及配送服务，包括工业及消费化学品的危险品处理、牌照申请及运输。我们亦可以透过集运及分拨优化配送，以满足客户业务的特定需求。',
            },
            {
                title: '润滑油物流',
                text0: '我们专业的润滑油物流服务涵盖以自置及运营驳船进行的海运，以至离岸作业包括仓储和配送，以及倾倒集装罐箱至中型散货罐箱。',
            },
            {
                title: '跨境集运枢纽',
                text0: '我们位于香港的跨境集运枢纽涵盖收货及按目的地分货服务，亦提供清关，以及跨境送递至中国內地各城市。',
            },
            {
                title: '增值服务',
                text0: '我们的增值服务包括印贴标签、薰蒸、重新包装、抽样等。',
            },
        ],
        typeName7: '汽车',
        typeContent7: [
            {
                title: '',
                text0: '六渡物流为汽车行业提供综合供应链解决方案，当中包括原材料的采购和供应、工厂生产、出厂汽车交付至终端客户，以及售后物流。',
                text1: '透过流程为本的模式，我们的综合汽车物流服务可迅速配合产品组合和货量上的变化。我们的服务包括上游生产线物流、买家集运、越库交接运输，以及供应商管理等。',
            },
            {
                title: '供应商库存管理',
                text0: '我们的进货物流和供应商库存管理解决方案，能确保原材料全年持续供应以支援你的生产线，当中包括供应商枢纽营运、目录管理、进度/后拉式看板生产、定时交货、以及循环取货等。',
            },
            {
                title: '分部装配及组装',
                text0: '我们的解决方案把汽车的最终组装安排在接近终端用户的地区进行，务求减低折旧风险。解决方案亦包括物料清单汇编、编号管理、提货及分货、组装、排序，以及测试零件管理等。',
            },
            {
                title: '零件及服务配件物流',
                text0: '我们提供缜密的物流管理，助你改善零件库存和订单准确性，从而优化库存水平及缩短汽车周期。我们的服务包括组装、质量检验、维修、关键零件更换、以及库存预测/分析等。',
            },
            {
                title: '售后物流',
                text0: '我们的售后物流由4S经销店配送、逆向物流、零件及服务配件退货管理，以至零件及服务配件区域分配、产品回收及传呼中心支援皆一应俱全。',
            },
            {
                title: '增值服务',
                text0: '我们的增值服务包括功能测试、汽车清洗、轮胎检查和充气、充电、半散件/全散件组装，以及项目物流等。',
            },
        ],
    },
    contac: {
        mailbox: '如有紧急事务，麻烦发送邮件至我们的公共邮箱：',
        formTitle: '协助与联系我们',
        form1: '主题',
        formTip1: '请输入主题',
        form2: '具体信息',
        formTip2: '请输入具体信息',
        form3: '姓名',
        formTip3: '请输入姓名',
        form4: '电邮',
        formTip4: '请输入电邮',
        form5: '公司名称',
        formTip5: '请输入公司名称',
        form6: '所在省份或地区',
        formTip6: '请选择所在省份或地区',
        form7: '地址',
        formTip7: '请输入地址',
        formSure: '提交'
    },
    api:{
        suc: "提交成功"
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh.js